import { useQuery } from "@tanstack/react-query";

import { ISoccerCommentaryMatch, SoccerMatchStatus } from "../../../types";
import { getSoccerMatchCommentary } from "../api";
import { pollIntervalMs } from "../utils/refreshCadence";

export function useMatchCommentary({
  matchId,
  matchStatus,
  lang,
  kickoffTime,
}: {
  matchId: string;
  matchStatus: SoccerMatchStatus;
  lang?: string;
  kickoffTime?: string;
}) {
  const isActiveMatch = [SoccerMatchStatus.PLAYING, SoccerMatchStatus.PLAYED].includes(matchStatus);

  const { isLoading, error, data, refetch } = useQuery<ISoccerCommentaryMatch>({
    queryKey: [`commentary-${matchId}`],
    queryFn: () => getSoccerMatchCommentary({ matchId, lang }),
    enabled: !!matchId?.length && isActiveMatch,
    staleTime: 0,
    refetchInterval: () => pollIntervalMs("commentary", kickoffTime),
  });

  return { isLoading, error, data, refetch };
}
